import { Component, inject, ViewChild } from "@angular/core";
import { DespachoService } from "../../../services/despacho/despacho.service";
import {
  FormBuilder,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from "@angular/forms";
import { MatToolbarModule } from "@angular/material/toolbar";
import { MatButtonModule } from "@angular/material/button";
import { MatIconModule } from "@angular/material/icon";
import { MatTabsModule } from "@angular/material/tabs";
import { MatInputModule } from "@angular/material/input";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatRadioModule } from "@angular/material/radio";
import {
  MatDatepicker,
  MatDatepickerModule,
} from "@angular/material/datepicker";
import { MatSelectModule } from "@angular/material/select";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { AsyncPipe, CommonModule } from "@angular/common";
import { MatChipsModule } from "@angular/material/chips";
import { EditorModule } from "@tinymce/tinymce-angular";
import { Editor, NgxEditorModule, Toolbar } from "ngx-editor";
import { MatCheckboxModule } from "@angular/material/checkbox";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { MatCardModule } from "@angular/material/card";
import { provideNativeDateAdapter } from "@angular/material/core";
import { ActivatedRoute, Router, RouterLink } from "@angular/router";
import { forkJoin, take } from "rxjs";
import { AcuerdosService } from "../../../services/acuerdos/acuerdos.service";
import { OrderByPipe } from "../../../pipes/order-by.pipe";
import { ConfirmDialogComponent } from "../../../confirm-dialog/confirm-dialog.component";
import { MatDialog } from "@angular/material/dialog";
import { LoadingService } from "../../../loading/loading.service";
import { stripHtml } from "../../acuerdo/detalle-tema/dtoDetalleTema";
import { MatTooltipModule } from "@angular/material/tooltip";
import { EntregablesService } from "../../../services/entregables/entregables.service";
import { toolbarEditor } from "../../../utils";
import { Store } from "@ngrx/store";
import { AppState } from "../../../app.state";
import { setContador } from "../../../states/despacho/actions";
import { AcuerdosUtilsService } from "../../acuerdo/utils";
import { OrderAscDescPipe } from "../../../pipes/asc-desc-order/order-asc-des.pipe";

@Component({
  selector: "app-mover-despacho",
  standalone: true,
  imports: [
    MatToolbarModule,
    MatButtonModule,
    MatIconModule,
    MatTabsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    FormsModule,
    MatRadioModule,
    MatDatepickerModule,
    MatSelectModule,
    MatAutocompleteModule,
    //AsyncPipe,
    MatChipsModule,
    EditorModule,
    CommonModule,
    NgxEditorModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatCardModule,
    OrderByPipe,
    MatTooltipModule,
    RouterLink,
    OrderAscDescPipe,
  ],
  providers: [provideNativeDateAdapter()],
  templateUrl: "./mover-despacho.component.html",
  styleUrl: "./mover-despacho.component.css",
})
export class MoverDespachoComponent {
  @ViewChild("picker") picker!: MatDatepicker<Date>;

  onEditorChange(content: string): void {
    this.formDespacho.get("descripcionTema")?.setValue(this.stripHtml(content));
    this.formDespacho.get("descripcionTema")?.markAsTouched();
  }
  public mostrarCalendario = false;
  public formDespacho!: FormGroup;
  public tipoDespacho: any[] = [];
  private formBuilder: FormBuilder = inject(FormBuilder);
  public temaAMover: any = [];
  public toolbar: Toolbar = toolbarEditor;
  editor!: Editor;
  html = "";
  catTipoFormaEnvio: any = [];
  catFormaEnvio: any = [];
  catTipoTema: any = [];
  catCategorizacion: any = [];
  catCategoria: any = [];
  catAnalista: any = [];
  catSupervisor: any = [];
  catCoordinador: any = [];
  minDate!: Date;
  private readonly store: Store<AppState> = inject(Store);

  constructor(
    private despachoService: DespachoService,
    private route: ActivatedRoute,
    private acuerdosService: AcuerdosService,
    public dialog: MatDialog,
    private loadingService: LoadingService,
    private router: Router,
    private entregablesService: EntregablesService,
    private acuerdoUtils: AcuerdosUtilsService
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.loadingService.show();
    this.minDate = new Date();
    this.editor = new Editor();
    const id_tema = this.route.snapshot.paramMap.get("id_tema") ?? "";
    if (!id_tema) {
      return;
    }

    forkJoin({
      tipo_forma_envio: this.despachoService
        .getCatTipoFormaEnvio("tipo_forma_envio")
        .pipe(take(1)),
      tipo_tema: this.despachoService
        .getCatTipoFormaEnvio("tipo_tema")
        .pipe(take(1)),
      categorizacion: this.despachoService
        .getCatTipoFormaEnvio("categorizacion")
        .pipe(take(1)),
      tema: this.despachoService.consultarTemaAMover(id_tema, 2).pipe(take(1)),
      acuerdos: this.acuerdosService.obtenerAcuerdos(4, "", "").pipe(take(1)),
      getResponsablesFB: this.despachoService.getResponsablesFB().pipe(take(1)),
      categorias: this.despachoService.getCategoria().pipe(take(1)),
    }).subscribe({
      next: ({
        tipo_forma_envio,
        tipo_tema,
        categorizacion,
        tema,
        acuerdos,
        getResponsablesFB,
        categorias,
      }) => {
        this.catTipoFormaEnvio = tipo_forma_envio.tipoEnvio;
        this.tipoDespacho = tipo_forma_envio.tipoEnvio.filter(
          (item: any) => item.id != 2
        );

        console.log("tema=>>>>>>", tema);
        console.log("getResponsablesFB=>>>>>>", getResponsablesFB);

        this.temaAMover = tema;
        this.catFormaEnvio = acuerdos.acuerdos.map((acuerdo) => {
          return { ...acuerdo };
        });
        console.log(" this.catFormaEnvio", this.catFormaEnvio);

        this.catTipoTema = tipo_tema.tipoTema;
        this.catCategorizacion = this.acuerdoUtils.getCategorizacioCombo(
          categorizacion.tiposCategorizacion
        );

        // Uso
        this.catAnalista = this.filtrarResponsables(
          getResponsablesFB.responsables,
          "analista"
        );
        this.catSupervisor = this.filtrarResponsables(
          getResponsablesFB.responsables,
          "supervisor"
        );
        this.catCoordinador = this.filtrarResponsables(
          getResponsablesFB.responsables,
          "coordinador"
        );
        console.log("categorias", categorias);
        this.catCategoria = categorias.categoria;
        this.loadingService.hide();
      },
      error: (err) => {
        this.loadingService.hide();
        console.error("Error al obtener datos:", err);
      },
    });
  }

  filtrarResponsables(
    responsables: Record<string, any[]>,
    propiedad: string
  ): any[] {
    return (
      responsables[propiedad]?.filter(
        (item) => item.banEsActivo && item.mostrar
      ) || []
    );
  }

  ngOnDestroy(): void {
    this.editor.destroy();
  }

  setFechaAcuerdo(formaEnvio: any) {
    const fecha = this.catFormaEnvio.find(
      (cat: any) => cat.idFE === formaEnvio
    ).fechaAcuerdo;

    this.formDespacho.get("fechaAcuerdo")?.setValue(fecha);
  }
  setCategorizaacion() {
    const confidencial = this.formDespacho.get("banEsConfidencial")?.value;
    this.catCategorizacion = this.catCategorizacion.map((cat: any) => {
      if (cat.descripcion === "C" && !confidencial) {
        return { ...cat, disabled: false };
      } else if (cat.descripcion !== "C" && confidencial) {
        return { ...cat, disabled: false };
      } else {
        return { ...cat, disabled: true };
      }
    });

    if (!confidencial) {
      if (
        this.catCategorizacion.filter(
          (item: any) => item.id == "-KcOsYIkmr2FHgi4ubym"
        ).length != 0
      ) {
        this.formDespacho
          .get("id_categorizacion")
          ?.setValue("-KcOsYIkmr2FHgi4ubym");
      } else {
        this.formDespacho.get("id_categorizacion")?.setValue("");
        this.formDespacho.get("id_categorizacion")?.markAsTouched();
      }
    }
    if (confidencial) {
      this.formDespacho.get("id_categorizacion")?.setValue("");
      this.formDespacho.get("id_categorizacion")?.markAsTouched();
    }

    if (!confidencial) {
      this.formDespacho
        .get("id_fb_resp_analista")
        ?.setValidators([Validators.required]);
      this.formDespacho
        .get("id_fb_resp_supervisor")
        ?.setValidators([Validators.required]);
    } else {
      this.formDespacho.get("id_fb_resp_analista")?.clearValidators();
      this.formDespacho.get("id_fb_resp_analista")?.setErrors(null);
      this.formDespacho.get("id_fb_resp_supervisor")?.clearValidators();
      this.formDespacho.get("id_fb_resp_supervisor")?.setErrors(null);
    }

    this.formDespacho.get("id_fb_resp_analista")?.updateValueAndValidity();
    this.formDespacho.get("id_fb_resp_supervisor")?.updateValueAndValidity();
  }

  loadData() {
    console.log("this.temaAMover.nombreTema", this.temaAMover);

    this.formDespacho.get("nombreTema")?.setValue(this.temaAMover.nombreTema);
    this.formDespacho.get("entradas")?.setValue(this.temaAMover.entradas);
    this.formDespacho.get("id_tema")?.setValue(this.temaAMover.id_tema);
    this.formDespacho.get("tipo_forma_envio")?.disable();
    this.setCategorizaacion();
  }

  stripHtml = (html: string) => {
    const doc = new DOMParser().parseFromString(html, "text/html");
    return doc.body.textContent || "";
  };
  validarFecha(event: any) {
    this.formDespacho.get("fechaAcuerdo")?.setValue(null);
    if (event.value) {
      let selectedDate = this.formatDate(event.value);
      let formattedDates = this.catFormaEnvio.map((date: any) =>
        this.formatDate(new Date(date.fechaAcuerdo))
      );
      if (formattedDates.includes(selectedDate)) {
        this.formDespacho.get("fechaAcuerdoDate")?.setValue(null);
        this.picker.close();
        this.showModalError(
          "Error",
          "Ya existe un acuerdo con la fecha seleccionada"
        );
      }
    }
  }

  formatDate(date: Date) {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  }

  showModalError(title: string, message: string) {
    this.dialog.open(ConfirmDialogComponent, {
      width: "450px",
      data: {
        title,
        message,
        showButtons: {
          accept: true,
          cancel: false,
        },
        direction: "end",
        buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
      },
    });
  }

  getContador(value: any) {
    return value && value.length > 0 ? stripHtml(value).length : 0;
  }

  setFecha(name: string) {
    const control = this.formDespacho.get(name);

    if (control) {
      control.setErrors(null);
      control.clearValidators();
      control.setValue("");
      control.markAsUntouched();
      if (name === "id_forma_envio") {
        control.addValidators([Validators.required]);
        const fechaAcuerdoDateControl =
          this.formDespacho.get("fechaAcuerdoDate");
        if (fechaAcuerdoDateControl) {
          fechaAcuerdoDateControl.clearValidators();
          fechaAcuerdoDateControl.setErrors(null);
          console.log("fechaAcuerdoDateControl ", fechaAcuerdoDateControl);
        }
      }

      if (name === "fechaAcuerdoDate") {
        control.addValidators([Validators.required]);
        const idFormaEnvioControl = this.formDespacho.get("id_forma_envio");
        if (idFormaEnvioControl) {
          idFormaEnvioControl.clearValidators();
          idFormaEnvioControl.setErrors(null);
          console.log("idFormaEnvioControl ", idFormaEnvioControl);
        }
      }
    }
  }
  getCategoriaDescripcion(id: string): string {
    const categoria = this.catCategoria.find((item: any) => item.id === id);
    return categoria ? categoria.descripcion : "";
  }
  cancelar() {
    console.log("form", this.formDespacho);
    console.log("getRawValue", this.formDespacho.getRawValue());
    // this.initForm();
    const tipo_forma_envio = this.formDespacho.getRawValue().tipo_forma_envio;
    this.initForm();
    this.formDespacho.get("tipo_forma_envio")?.enable();
    this.formDespacho.get("tipo_forma_envio")?.setValue("");
    this.formDespacho.get("descripcionTema_html")?.setValue("");
    this.formDespacho.get("id_forma_envio")?.setValue(tipo_forma_envio);
    this.formDespacho.markAsUntouched();
  }
  initForm() {
    this.formDespacho = this.formBuilder.group({
      tipo_forma_envio: [""],
      nombreTema: [{ value: "", disabled: true }, Validators.required],
      descripcionTema_html: ["", Validators.required],
      banEsImpreso: [false, Validators.required],
      fechaAcuerdoDate: [""],
      fechaAcuerdo: [""],
      id_tipo_tema: ["", Validators.required],
      banEsConfidencial: [false, [Validators.required]],
      id_categorizacion: ["", Validators.required],
      id_categoria: ["", Validators.required],
      id_fb_resp_analista: ["", Validators.required],
      id_fb_resp_supervisor: ["", Validators.required],
      id_fb_resp_coordinador: ["", Validators.required],
      id_tema: ["", Validators.required],
      entradas: [[]],
      descripcionTema: ["", Validators.required],
      id_forma_envio: ["", Validators.required],
    });
  }
  async guardar() {
    this.loadingService.show();
    console.log("valido", this.formDespacho.valid);
    let data = this.formDespacho.getRawValue();

    if (this.formDespacho.value.fechaAcuerdoDate) {
      data.id_forma_envio = null;
      if (data.hasOwnProperty("tipo_forma_envio")) {
        delete data.tipo_forma_envio;
      }
      data.fechaAcuerdoDate =
        this.formDespacho.value.fechaAcuerdoDate.toISOString();
      data.fechaAcuerdo = this.formatDate(new Date(data.fechaAcuerdoDate));
    }

    if (this.formDespacho.value.id_forma_envio) {
      if (data.hasOwnProperty("fechaAcuerdoDate")) {
        delete data.fechaAcuerdoDate;
      }
      if (data.hasOwnProperty("tipo_forma_envio")) {
        delete data.tipo_forma_envio;
      }
      data.fechaAcuerdo = this.formatDate(
        new Date(this.formDespacho.value.fechaAcuerdo)
      );
    }

    if (
      this.formDespacho.valid &&
      (this.formDespacho.get("fechaAcuerdo")?.value ||
        this.formDespacho.get("fechaAcuerdoDate")?.value)
    ) {
      try {
        const moverDespacho =
          await this.despachoService.moverTemaDespachoAcuerdoMrB(data);

        if (!moverDespacho.error) {
          //this.store.dispatch(setContador());
          const modal = this.dialog.open(ConfirmDialogComponent, {
            width: "450px",
            data: {
              title: "Éxito",
              message: "Se movió correctamente el tema.",
              showButtons: {
                accept: true,
                cancel: false,
              },
              direction: "end",
              buttonsName: { cancel: "CANCELAR", accept: "ACEPTAR" },
            },
            disableClose: true,
          });

          //this.showModalError("Éxito", "Se movió correctamente el tema.");

          modal.componentInstance.confirmAction.subscribe(() => {
            this.router.navigate([`/despacho/listado`]);
          });
          modal.componentInstance.cancelAction.subscribe(() => {
            this.router.navigate([`/despacho/listado`]);
          });
        }
      } catch (error) {
        this.loadingService.hide();
        console.log("error", error);
      }
    }
  }

  descargarEntregable(entregable: any, entrada: any) {
    console.log("entregable", entregable);
    this.loadingService.show();
    const id_entrada = entrada.idEntrada ?? entrada.id_entrada;
    const id_entregable = entregable.idEntregable ?? entregable.id_entregable;

    this.entregablesService
      .descargarEntregable({
        entrada: id_entrada,
        entregable: id_entregable,
      })
      .subscribe((result) => {
        console.log("file", result);

        if (result.error || result.data.error) {
          this.loadingService.hide();
          this.showModalError("Error", result.data.message.mensaje);
        } else {
          const ifrm = document.createElement("iframe");
          ifrm.setAttribute("src", result.data[0]);
          ifrm.style.width = "0px";
          ifrm.style.height = "0px";
          ifrm.style.border = "0";
          document.body.appendChild(ifrm);
          setTimeout(() => {
            document.body.removeChild(ifrm);
          }, 1000);
          this.loadingService.hide();
        }
      });
  }
}
